import React from 'react';
import { InputProps, ReadOnlyField } from '@indigo-ag/component-module';

import { InputNumberMask, InputNumberMaskProps, parseNumberToLocale, utils } from 'shared';

interface EditableNumberFieldProps extends InputNumberMaskProps {
  label: string;
  readonly?: boolean;
}

export const EditableNumberField: React.FunctionComponent<EditableNumberFieldProps & InputProps> = ({
  label,
  numberValue,
  readonly = false,
  onNumberChange,
  ...inputProps
}) => {
  const labelTitle = utils.text.toTitleCase(label);

  return readonly ? (
    <ReadOnlyField label={labelTitle} value={parseNumberToLocale(numberValue) || '-'} />
  ) : (
    <InputNumberMask
      label={labelTitle}
      name={`enf-${label.split(' ').join('-')}`}
      sizeVariant="slim"
      numberValue={numberValue}
      onNumberChange={onNumberChange}
      {...inputProps}
    />
  );
};
